import React from 'react';
import './FeaturedProducts.css';

const FeaturedProducts = () => {
  const featuredProducts = [
    {
      name: 'Leaf Springs',
      description: 'Heavy-duty parabolic leaf springs delivering excellent load distribution and ride comfort. Durable suspension parts for heavy commercial vehicles.',
      image: '/Photos/Products/Leaf springs VOLVO FM460.png'
    },
    {
      name: 'Pressure Plates',
      description: 'High-performance pressure plates ensuring consistent clutch engagement and smooth power delivery. Precision-engineered for optimal performance.',
      image: '/Photos/Products/Pressure Plates Volvo FM460.png'
    },
    {
      name: 'Clutch Plates',
      description: 'Heavy-duty clutch plates for smooth power transmission and extended durability. High-performance parts for reliable operation.',
      image: '/Photos/Products/Clutch Plates Volvo FM460.png'
    }
  ];

  return (
    <section className="featured-products">
      <div className="featured-products-container">
        <div className="featured-products-header">
          <h2 className="featured-products-title">Featured Products</h2>
          <p className="featured-products-subtitle">
            Premium quality spare parts for your heavy commercial vehicles
          </p>
        </div>

        <div className="featured-products-grid">
          {featuredProducts.map((product, index) => (
            <div key={index} className="featured-product-card">
              <div className="featured-product-image-container">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="featured-product-image"
                />
              </div>
              <div className="featured-product-info">
                <h3 className="featured-product-name">{product.name}</h3>
                <p className="featured-product-description">{product.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="featured-products-cta">
          <a href="#products" className="view-all-button">
            View All Products
            <svg 
              className="button-arrow" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M17 8l4 4m0 0l-4 4m4-4H3" 
              />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;

